import { IApplicationState } from '../../../../../../../types/types';

export const getShowColorsEditTooltip = (
    state: IApplicationState,
): boolean => {
    return state && state.cardPanel && state.cardPanel.cardColors && state.cardPanel.cardColors.isShowEditTooltip;
};
